"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

var _index2 = require("../../../utils/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : LOGO : STYLES--------------- ++++++++++ */


var _default = {
  logo: {
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    display: 'block',
    // insticator (icon + text)
    '&.name-insticator': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/logo-insticator.png)"),
      height: (0, _index.pxToEm)(11),
      width: (0, _index.pxToEm)(125)
    },
    // insticator (icon only)
    '&.name-insticator-icon': {
      backgroundImage: "url(".concat(_index2.url.static.files.images, "/iui/logo-insticator-icon.svg)"),
      height: (0, _index.pxToEm)(24),
      width: (0, _index.pxToEm)(39)
    }
  }
};
exports.default = _default;